import {
    StyleSheet, View, Text
} from "react-native";

import { getTimestampToDate, numberOfCommas } from "../../../common/util";
import { FONT } from "../../../value/staticValues";

import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";
import { ReactComponent as RedirImg } from '../../../img/ico-prefix-move.svg';
import { ReactComponent as CpuImg } from '../../../img/ico-vpc-list-cpu.svg';
import { ReactComponent as MemImg } from '../../../img/ico-vpc-list-memory.svg';
import { ReactComponent as VpcImg } from '../../../img/ico-vpc-list-vpc.svg';
import { ReactComponent as StorageImg } from '../../../img/ico-vpc-list-storage.svg';
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as SearchNoResultImg } from "../../../img/ico-search-no-result.svg";
import { ProjectQuota } from "./ProjectDetailContainer";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { Fragment, useEffect, useState } from "react";
import { ProjectData, ProjectQuotaData } from "./ProjectData";



interface ProjectDetailProps extends ContentContainerProps {
    projectQuotas: ProjectQuota[];
    regions: DropdownType[];
    updateFunction: Function;
    detailData: ProjectData|null;

}


export default function ProjectDetail(props:ProjectDetailProps) {
    const { t } = useTranslation();

    const [regionId, setRegionId] = useState("");
    const [regionName, setRegionName] = useState("");
    const [projectQuota, setProjectQuota] = useState<ProjectQuotaData>();

    useEffect(() => {
        if(props.regions && !regionId) {
            setRegionId(props.regions.length > 0 ? props.regions[0].value : "");
            setRegionName(props.regions.length > 0 ? props.regions[0].value : "");
        }
    }, [props.regions])

    useEffect(()=>{
        if(props.detailData)
            setProjectQuota(props.detailData.project_quotas[0])
    },[props.detailData])


    return (
        <ContentBox title={t("PROJECT_MGMT_DETAIL_TITLE")} subtitle={t("PROJECT_MGMT_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={style.topContainer}>
                <View style={{flexDirection: "row"}}>
                    <View style={{width: 840, marginRight: 10}}>
                    <View style={{...style.boxContainer, minHeight: 320}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                                <Text style={style.boxContentTitle}>
                                    {t("PROJECT_DETAIL_INFO_TEXT")}
                                </Text>
                            </View>
                            <View style={{flexDirection: "row"}}>
                                <View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("PROJECT_NAME_TEXT")}
                                        </Text>
                                        <Text style={{...style.boxContentDataText}}>
                                            { props.detailData?.project_name }
                                        </Text>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("PROJECT_STATE_TEXT")}
                                        </Text>
                                        <View style={{ flexDirection: "row", alignItems: "center",}}>
                                            {
                                                <StatusStableImg/>
                                            }
                                            <Text style={{
                                                fontFamily: FONT.REGULAR,
                                                fontSize: 12,
                                                marginLeft: 4,
                                                color: "#3a8344"
                                            }}>
                                                {t("ACTIVE_TEXT")}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("DOMAIN_NAME_TEXT")}
                                        </Text>
                                        <Text style={style.boxContentDataText}>
                                            {'Default'}
                                        </Text>
                                    </View>
                                    <View style={{flexDirection: "row", marginBottom: 30, width: 730}}>
                                        <Text style={{...style.boxContentHeaderText, marginTop: 6}}>
                                            {t("ACCOUNT_ID_TEXT")}
                                        </Text>
                                        <View style={{flexDirection: "row", alignItems: "center", width: 610}}>
                                            <Text style={{...style.boxContentDataText, color: "#0853fb", marginLeft: 10}}>
                                            {
                                                props?.detailData?.users.map((v, i) => {
                                                    return v.email + (props.detailData?.users.length !== i+1 ? ', ' : '')
                                                })
                                            }
                                            </Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>


                        <View style={{...style.boxContainer, height: 360}}>
                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                    {t("USED_RESOURCE_TEXT")}
                                </Text>
                                <Text style={{
                                    marginLeft: 95,
                                    fontFamily: FONT.REGULAR,
                                    fontSize: 12,
                                    color: "#8c8c8c"
                                }}>
                                    {t("PROJECT_DETAIL_USED_RESOURCE_MESSAGE")}
                                </Text>
                            </View>
                            <View style={{...style.resourceBox, marginTop: 40, height: 128}}>
                                <View style={{height: 90}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={style.imgBox}>
                                            <CpuImg/>
                                        </View>
                                        <Text style={style.resourceFixedText}>
                                            {t("INSTANCE_CPU_TEXT")}
                                        </Text>
                                        <Text style={style.resourceDataText}>
                                            {numberOfCommas(props.detailData?.vcpu_count || 0)}
                                        </Text>
                                        <Text style={style.resourceSubText}>cores</Text>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginTop: 20}}>
                                        <View style={style.imgBox}>
                                            <MemImg/>
                                        </View>
                                        <Text style={style.resourceFixedText}>
                                            {t("INSTANCE_MEMORY_TEXT")}
                                        </Text>
                                        <Text style={style.resourceDataText}>
                                            {props.detailData?.memory_capacity_mb || '0'}
                                        </Text>
                                        <Text style={style.resourceSubText}>MB</Text>
                                    </View>
                                </View>
                                <View style={{justifyContent: "center", height: 90, marginLeft: 145}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={style.imgBox}>
                                            <VpcImg/>
                                        </View>
                                        <Text style={style.resourceFixedText}>
                                            {t("INSTANCE_COUNT_TEXT")}
                                        </Text>
                                        <Text style={{...style.resourceDataText, color: "#0853fb"}}>
                                            {numberOfCommas(props.detailData?.vm_count || 0)}
                                        </Text>
                                    </View>
                                </View>
                            </View>

                            <View style={{...style.resourceBox, marginTop: 10}}>
                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <View style={style.imgBox}>
                                        <StorageImg/>
                                    </View>
                                    <Text style={style.resourceFixedText}>
                                        {t("VM_VOLUME_SIZE_TEXT")}
                                    </Text>
                                    <Text style={style.resourceDataText}>
                                        {props.detailData?.volume_capacity_gb || '0'}
                                    </Text>
                                    <Text style={style.resourceSubText}>GB</Text>
                                </View>

                                <View style={{marginLeft: 168}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={style.imgBox}>
                                            <StorageImg/>
                                        </View>
                                        <Text style={style.resourceFixedText}>
                                            {t("VOLUME_COUNT_TEXT")}
                                        </Text>
                                        <Text style={{...style.resourceDataText, color: "#0853fb"}}>
                                            {numberOfCommas(props.detailData?.volume_count || 0)}
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>


                        <View style={props.detailData?.project_quotas && props.detailData?.project_quotas?.length > 0 ? {...style.boxContainer, height: 700} : {...style.boxContainer, height: 200}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                    {t("ASSIGN_RESOURCE_TEXT")}
                                </Text>
                                <Text style={{
                                    marginLeft: 75,
                                    fontFamily: FONT.REGULAR,
                                    fontSize: 12,
                                    color: "#8c8c8c"
                                }}>
                                    {t("PROJECT_DETAIL_ASSIGN_RESOURCE_MESSAGE")}
                                </Text>
                                {
                                    <div
                                        style={{
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            width: 66, height: 24,
                                            marginLeft: "auto",
                                            borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                            backgroundColor: "#fff",
                                            fontFamily: FONT.REGULAR,
                                            fontSize: 12,
                                            color: "#333",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {props.updateFunction(projectQuota)}}
                                    >
                                        {t("RESOURCE_QUOTA_UPDATE_TEXT")}
                                        <RedirImg style={{marginLeft: 3}}/>
                                    </div>
                                }
                            </View>

                            <View style={{flexDirection: "row"}}>
                                <View style={{width: 490}}>
                                    {
                                        props.detailData?.project_quotas && props.detailData?.project_quotas?.length > 0 ?
                                        <Fragment>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                                <Text style={style.boxContentHeaderText}>
                                                    {t("REGION_TEXT")}
                                                </Text>

                                                {props.detailData?.project_quotas.map((v) => {
                                                    return (
                                                        <Text style={{width: 200,
                                                            fontFamily: FONT.REGULAR,
                                                            fontSize: 13,
                                                            lineHeight: 12,
                                                            color: "#333"}}>
                                                            {v.region_id}
                                                        </Text>
                                                    )
                                                })}
                                            </View>

                                            <View style={{...style.resourceBox, flexDirection: "column", marginTop: 20, height: 150}}>
                                                <Text style={style.resourceBoxTitleText}>{t("INSTANCE_RESOURCE_TEXT")}</Text>
                                                <View style={{flexDirection: "row"}}>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("VM_MAX_COUNT_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.vm_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginLeft: 80, marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("VCPU_MAX_COUNT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.vcpu_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                </View>

                                                <View style={{flexDirection: "row"}}>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("MEMORY_MAX_COUNT_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {props.detailData?.project_quotas[0]?.vmemory_max_capacity_mb || 0} MB
                                                        </Text>
                                                    </View>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginLeft: 80, marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("KEY_PAIR_MAX_COUNT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.key_pair_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                </View>
                                            </View>

                                            <View style={{...style.resourceBox, flexDirection: "column", marginTop: 20, height: 150}}>
                                                <Text style={style.resourceBoxTitleText}>{t("STORAGE_RESOURCE_TEXT")}</Text>
                                                <View style={{flexDirection: "row"}}>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("VOLUME_MAX_COUNT_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.volume_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginLeft: 80, marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("VOLUME_SNAPSHOT_MAX_COUNT_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.subnet_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                </View>

                                                <View style={{flexDirection: "row"}}>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("VOLUME_MAX_SIZE_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {props.detailData?.project_quotas[0]?.block_storage_capacity_gb + ' GB' || 0 + ' GB'}
                                                        </Text>
                                                    </View>
                                                </View>
                                            </View>

                                            <View style={{...style.resourceBox, flexDirection: "column", marginTop: 20, height: 150}}>
                                                <Text style={style.resourceBoxTitleText}>{t("NETWORK_RESOURCE_TEXT")}</Text>
                                                <View style={{flexDirection: "row"}}>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("NETWORK_MAX_COUNT_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.network_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginLeft: 80, marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("SUBNET_MAX_COUNT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.subnet_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                </View>
                                                <View style={{flexDirection: "row"}}>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("SECURITY_GROUP_MAX_COUNT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.security_group_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                    <View style={{flexDirection: "row", alignItems: "center", marginLeft: 80, marginBottom: 30}}>
                                                        <Text style={{...style.boxContentHeaderText, width: 120}}>
                                                            {t("SECURITY_GROUP_RULE_MAX_COUNT")}
                                                        </Text>
                                                        <Text style={{...style.boxContentDataText, width: 100}}>
                                                            {numberOfCommas(props.detailData?.project_quotas[0]?.security_group_rule_max_count || 0)}
                                                        </Text>
                                                    </View>
                                                </View>
                                            </View>
                                        </Fragment>
                                    :
                                    <View style={{alignItems: "flex-end", justifyContent:"center", marginRight: 100, marginBottom: 30}}>
                                        <SearchNoResultImg style={style.innerItemEmptyImg}/>
                                        <Text style={style.innerItemEmtpyText}>
                                            {t("SEARCH_NO_RESULT_MAIN_TEXT")}
                                        </Text>
                                    </View>
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}

const style = StyleSheet.create({
    topContainer: {
        width: 1090,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentHeaderText: {
        width: 80,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    settingImg: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    resourceBox: {
        flexDirection: "row",
        width: 760, minHeight: 70,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
        padding: 20,
    },
    resourceBoxTitleText: {
        marginBottom: 20,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    imgBox: {
        alignItems: "center", justifyContent: "center",
        width: 36, height: 36,
        marginRight: 16,
        borderRadius: 10,
        backgroundColor: "rgba(182, 191, 206, 0.3)",
    },
    resourceFixedText: {
        width: 75,
        marginRight: 90,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    resourceDataText: {
        fontFamily: FONT.BOLD,
        fontSize: 14,
        lineHeight: 14,
        color: "#333"
    },
    resourceSubText: {
        marginLeft: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    innerItemEmptyImg: {
        width: 50,
        height: 50,
        marginRight: 30,
    },
    innerItemEmtpyText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#4d5367"
    },
});